import { render, staticRenderFns } from "./ClockHistoric.vue?vue&type=template&id=07a765a9&"
import script from "./ClockHistoric.vue?vue&type=script&lang=ts&"
export * from "./ClockHistoric.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports